import React, { FC } from 'react';
import * as S from './homeHeatMapLegend.styles';

/**
 * Heat map legend.
 */
export const HomeHeatMapLegend: FC = () => {
  return (
    <S.Container>
      <S.Scale />
      <S.Labels>
        <S.Label>120</S.Label>
        <S.Label>100</S.Label>
        <S.Label>80</S.Label>
        <S.Label>60</S.Label>
        <S.Label>40</S.Label>
        <S.Label>20</S.Label>
        <S.Label>0</S.Label>
      </S.Labels>
    </S.Container>
  );
};
